export const SUPPORT_EMAIL = "Maryam-Al-Zeyoudi@hotmail.com";

export const content = {
  ar: {
    dir: "rtl",
    langName: "العربية",
    otherLang: "English",
    brand: { name: "بيوت المعرفة", latin: "Al Maarifah Houses", tag: "تطبيق iOS التعليمي" },
    nav: { support: "الدعم", about: "عن التطبيق", privacy: "سياسة الخصوصية" },
    hero: {
      badge: "الدعم الرسمي لتطبيق iOS",
      line1: "بيوت المعرفة",
      line2: "مبادرة رقمية تعليمية",
      line3: "لتعزيز الانتماء والمشاركة والإنجاز والتنافس الإيجابي.",
      ctaHelp: "الحصول على المساعدة",
      ctaPrivacy: "سياسة الخصوصية",
      meta: ["ثنائي اللغة", "ستة بيوت", "بدون تتبع"],
    },
    marquee: ["الانتماء", "المشاركة", "الإنجاز", "التنافس الإيجابي", "التكريم", "بيوت المعرفة"],
    about: {
      chapter: "01",
      title: "عن التطبيق",
      p1: "بيوت المعرفة مبادرة مدرسية رقمية ثنائية اللغة (العربية والإنجليزية) مبنية حول ستة بيوت. يدعم التطبيق التفاعل والإنجازات والنقاط والتصويت والمسابقات والتكريم ونشر المعلومات العامة.",
      p2: "لا تتوفر جميع الميزات لجميع المستخدمين: بعض الميزات الإدارية والخاصة بالموظفين تتطلب حسابات مصرحًا بها تُمنح من الجهة التعليمية، بينما يمكن تصفح المحتوى العام دون تسجيل الدخول.",
      pillars: [
        { title: "الانتماء", desc: "روح البيت الواحد والعمل الجماعي" },
        { title: "المشاركة", desc: "تفاعل الطلاب في الأنشطة والفعاليات" },
        { title: "الإنجاز", desc: "توثيق الإنجازات والاحتفاء بها" },
        { title: "التنافس الإيجابي", desc: "نقاط ومسابقات بروح رياضية" },
      ],
    },
    help: {
      chapter: "02",
      title: "الحصول على المساعدة",
      intro: "خطوات بسيطة تحل معظم المشكلات الشائعة قبل التواصل مع الدعم.",
      steps: [
        "تأكد من تحديث التطبيق إلى أحدث إصدار من App Store.",
        "تحقق من اتصال جهازك بالإنترنت.",
        "أغلق التطبيق وأعد فتحه إذا لم يتم تحميل إحدى الصفحات بشكل صحيح.",
        "إذا واجه حساب موظفين مصرح به مشكلة في الوصول، سجّل الخروج ثم سجّل الدخول مرة أخرى.",
        "إذا لم تصلك الإشعارات، تأكد من السماح بالإشعارات للتطبيق في إعدادات iOS.",
      ],
    },
    faq: {
      chapter: "03",
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "ما هو تطبيق بيوت المعرفة؟",
          a: "مبادرة رقمية تعليمية مدرسية ثنائية اللغة مبنية حول ستة بيوت، تدعم التفاعل والإنجازات والنقاط والتصويت والمسابقات والتكريم والمعلومات العامة.",
        },
        {
          q: "هل التطبيق متوفر باللغتين العربية والإنجليزية؟",
          a: "نعم، التطبيق ثنائي اللغة بالكامل، ويمكن التبديل بين العربية والإنجليزية من داخل التطبيق.",
        },
        {
          q: "هل أحتاج إلى حساب لاستخدام التطبيق؟",
          a: "يمكن تصفح المحتوى العام دون تسجيل الدخول. أما بعض الميزات الإدارية والخاصة بالموظفين فتتطلب حسابًا مصرحًا به.",
        },
        {
          q: "لماذا يستطيع بعض المستخدمين الوصول إلى ميزات لا يستطيع غيرهم الوصول إليها؟",
          a: "لأن بعض الميزات مخصصة لأصحاب الحسابات المصرح بها، مثل مدير المدرسة أو الإداريين أو الموظفين، وفقًا للأدوار الممنوحة لهم من الجهة التعليمية.",
        },
        {
          q: "كيف تُحتسب نقاط البيوت؟",
          a: "يقوم الموظفون المصرح لهم بمنح النقاط أو خصمها وفقًا للإنجازات والمشاركة ومعايير المدرسة، وتُجمَع النقاط لكل بيت لتظهر في النتائج والترتيب داخل التطبيق.",
        },
        {
          q: "هل يمكن للمستخدمين التصويت في الحملات؟",
          a: "نعم، يوفر التطبيق التصويت في الحملات المتاحة، وقد يكون بعض التصويت أو التقييم مقيدًا بالمستخدمين المصرح لهم بحسب طبيعة الحملة.",
        },
        {
          q: "لماذا لا تصلني الإشعارات؟",
          a: "تأكد من السماح بالإشعارات للتطبيق من إعدادات iOS، ومن تحديث التطبيق إلى أحدث إصدار، ومن توفر اتصال بالإنترنت.",
        },
        {
          q: "كيف أبلّغ عن مشكلة تقنية؟",
          a: "يمكنك التواصل معنا عبر نموذج الاتصال في هذه الصفحة أو عبر بريد الدعم الموضح أدناه، مع وصف المشكلة ونوع الجهاز وإصدار التطبيق.",
        },
        {
          q: "كيف أطلب الوصول إلى بياناتي الشخصية أو حذفها؟",
          a: "أرسل طلبك إلى بريد الخصوصية الموضح في صفحة سياسة الخصوصية، وسنتعامل مع الطلب وفقًا لما هو موضح في السياسة.",
        },
        {
          q: "هل تُستخدم بياناتي في الإعلانات أو التتبع؟",
          a: "لا. لا يستخدم التطبيق البيانات الشخصية لأغراض الإعلانات أو التتبع عبر التطبيقات أو المواقع. التفاصيل الكاملة للبيانات التي يعالجها التطبيق موضحة في سياسة الخصوصية.",
        },
      ],
    },
    contact: {
      chapter: "04",
      title: "التواصل والدعم",
      emailLabel: "بريد الدعم",
      note: "للدعم الفني أو الاستفسارات المتعلقة بالتطبيق، يرجى التواصل عبر البريد الإلكتروني الموضح أعلاه.",
      formTitle: "أرسل رسالتك",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسالة",
      send: "إرسال",
      sending: "جارٍ الإرسال...",
      successAr: "تم استلام رسالتك بنجاح. شكرًا لتواصلك معنا.",
      successEn: "Your message has been received successfully. Thank you for contacting us.",
      errorAr: "تعذر إرسال الرسالة. يرجى المحاولة مرة أخرى أو التواصل عبر البريد الإلكتروني.",
      errorEn: "Your message could not be sent. Please try again or contact us by email.",
      validation: "يرجى تعبئة جميع الحقول بشكل صحيح (الرسالة 10 أحرف على الأقل).",
    },
    footer: {
      support: "الدعم",
      privacy: "سياسة الخصوصية",
      about: "معلومات التطبيق",
      copyright: "© 2026 د. مريم راشد سليمان الزيودي",
      brand: "بيوت المعرفة",
      emailLabel: "الدعم:",
    },
    aboutPage: {
      metaTitle: "عن تطبيق بيوت المعرفة | Al Maarifah Houses",
      badge: "معلومات التطبيق",
      title: "عن تطبيق بيوت المعرفة",
      intro: "مبادرة رقمية تعليمية ثنائية اللغة تجمع بين التحفيز والانتماء والمنافسة الإيجابية في بيئة مدرسية واحدة.",
      purposeTitle: "الغرض",
      purpose: "تعزيز الانتماء والمشاركة والإنجاز والتنافس الإيجابي بين الطلاب من خلال نظام بيوت رقمي تفاعلي يخدم المجتمع المدرسي.",
      bilingualTitle: "دعم ثنائي اللغة",
      bilingual: "صُمم التطبيق بالكامل باللغتين العربية والإنجليزية، مع دعم كامل لاتجاه الكتابة من اليمين إلى اليسار ومن اليسار إلى اليمين.",
      housesTitle: "مفهوم البيوت الستة",
      housesIntro: "يقوم التطبيق على ستة بيوت تتنافس فيما بينها عبر النقاط والإنجازات والمشاركة في الأنشطة والمسابقات.",
      house: "البيت",
      accessTitle: "المحتوى العام والميزات المصرح بها",
      publicTitle: "للجميع",
      publicDesc: "يمكن تصفح المحتوى العام والمعلومات دون تسجيل الدخول.",
      staffTitle: "للموظفين المصرح لهم",
      staffDesc: "تتطلب الميزات الإدارية — مثل إدارة النقاط والإشعارات والحملات — حسابات مصرحًا بها تُدار من الجهة التعليمية.",
      linksTitle: "روابط مفيدة",
      toSupport: "صفحة الدعم",
      toPrivacy: "سياسة الخصوصية",
    },
    privacy: {
      metaTitle: "سياسة خصوصية بيوت المعرفة | Al Maarifah Houses Privacy Policy",
      badge: "وثيقة رسمية",
      title: "سياسة الخصوصية – بيوت المعرفة",
      updated: "آخر تحديث: يوليو 2026",
      sections: [
        {
          title: "مقدمة",
          paragraphs: [
            "توضح سياسة الخصوصية هذه كيفية تعامل تطبيق بيوت المعرفة (Al Maarifah Houses) على نظام iOS مع المعلومات. التطبيق مبادرة تعليمية مدرسية ثنائية اللغة (العربية والإنجليزية) مبنية حول ستة بيوت، وتهدف إلى تعزيز الانتماء والمشاركة والإنجاز والتنافس الإيجابي.",
            "باستخدامك التطبيق فأنت توافق على الممارسات الموضحة في هذه السياسة.",
          ],
        },
        {
          title: "المعلومات التي نجمعها",
          paragraphs: ["يجمع التطبيق أنواع البيانات التالية:"],
          list: [
            "الاسم — الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "عنوان البريد الإلكتروني — الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "معرّف المستخدم — الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "معرّف الجهاز — وهو رمز الإشعارات الفورية (APNs push token) ويُستخدم فقط لإرسال الإشعارات. الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "الصور — يمكن فقط للمستخدمين المصرح لهم (المدير/الإداريين) اختيار صور من مكتبة صور iPhone ورفعها لمحتوى التطبيق مثل أقسام \"عن التطبيق\" أو الإشعارات أو حملات التصويت. لا يتم جمع أي مقاطع فيديو، ولا يستخدم التطبيق الكاميرا. الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "محتوى آخر من المستخدم — مثل تعليقات النقاط، ومبررات الخصم، ومقترحات الإنجازات وملاحظاتها، وملاحظات المراجعة، وعمليات تصويت/تقييم الموظفين، ونصوص طلبات الدعم والخصوصية. الغرض: وظائف التطبيق. مرتبط بالمستخدم: نعم. التتبع: لا.",
            "تفاعل المنتج — مثل فتح التطبيق، والجلسات، ومشاهدات صفحات عامة محددة، وأوقات تسجيل الدخول، وحالة قراءة الإشعارات، وحالة مشاهدة الاحتفالات. الأغراض: التحليلات ووظائف التطبيق.",
          ],
          after: [
            "تستخدم بعض أحداث التحليلات العامة معرّفات مجهولة متغيرة، بينما ترتبط بعض بيانات تفاعل الموظفين بالحساب. التصنيف العام وفق إفصاح Apple: مرتبط بالمستخدم: نعم. التتبع: لا.",
            "لا يجمع التطبيق: العنوان الفعلي، رقم الهاتف، بيانات الصحة أو اللياقة، المعلومات المالية، الموقع الدقيق أو التقريبي، المعلومات الحساسة، جهات الاتصال، رسائل البريد أو الرسائل النصية، البيانات الصوتية، سجل التصفح، سجل البحث، المشتريات، بيانات الإعلانات، بيانات الأعطال، بيانات الأداء، بيانات التشخيص الأخرى، IDFA، IDFV، أو أي معرّفات إعلانية، ولا يجمع بيانات لأغراض الإعلانات أو التتبع عبر التطبيقات.",
          ],
        },
        {
          title: "كيف نستخدم المعلومات",
          list: [
            "تشغيل وظائف التطبيق الأساسية مثل الحسابات والأدوار والبيوت والنقاط والإنجازات.",
            "إدارة الحسابات المصرح بها وصلاحيات الموظفين والإداريين.",
            "إرسال الإشعارات الفورية المتعلقة بالتطبيق.",
            "عرض محتوى التطبيق مثل الأقسام التعريفية والحملات والتكريم.",
            "فهم كيفية استخدام التطبيق وتحسينه عبر تحليلات تفاعل المنتج.",
          ],
        },
        {
          title: "الإشعارات الفورية",
          paragraphs: [
            "يستخدم التطبيق خدمة الإشعارات الفورية من Apple (APNs)، بالإضافة إلى وسيط إشعارات (Emergent push relay / SuprSend) لتسليم الإشعارات. يتلقى معالج الإشعارات: معرّف المستخدم الداخلي، ونوع المنصة، ورمز الإشعارات (APNs push token)، وذلك لغرض تسليم الإشعارات فقط.",
            "يمكنك تعطيل الإشعارات في أي وقت من إعدادات iOS على جهازك.",
          ],
        },
        {
          title: "الصور والمحتوى المقدم من المستخدمين",
          paragraphs: [
            "يمكن فقط للمستخدمين المصرح لهم (المدير/الإداريين) اختيار صور من مكتبة صور الجهاز ورفعها لاستخدامها في محتوى التطبيق، مثل الأقسام التعريفية أو الإشعارات أو حملات التصويت. لا يصل التطبيق إلى الكاميرا ولا يجمع مقاطع فيديو.",
            "قد يقدم المستخدمون المصرح لهم محتوى نصيًا مثل تعليقات النقاط، ومبررات الخصم، ومقترحات الإنجازات، وملاحظات المراجعة، وعمليات التصويت والتقييم، ونصوص طلبات الدعم. يُستخدم هذا المحتوى لتشغيل وظائف التطبيق فقط.",
          ],
        },
        {
          title: "التحليلات وتفاعل المنتج",
          paragraphs: [
            "يسجل التطبيق بعض أحداث تفاعل المنتج، مثل فتح التطبيق، والجلسات، ومشاهدات صفحات عامة محددة، وأوقات تسجيل الدخول، وحالة قراءة الإشعارات، وحالة مشاهدة الاحتفالات.",
            "تستخدم بعض أحداث التحليلات العامة معرّفات مجهولة متغيرة، بينما ترتبط بعض بيانات تفاعل الموظفين بالحساب. تُستخدم هذه المعلومات لأغراض التحليلات ووظائف التطبيق، ولا تُستخدم للإعلانات أو التتبع.",
          ],
        },
        {
          title: "مشاركة البيانات ومقدمو الخدمات",
          paragraphs: [
            "نستخدم خدمة الإشعارات الفورية من Apple (APNs) ووسيط إشعارات (Emergent push relay / SuprSend) لتسليم الإشعارات فقط، ويتلقى هذا الوسيط معرّف المستخدم الداخلي ونوع المنصة ورمز الإشعارات.",
            "لا نبيع أي بيانات شخصية، ولا نشارك البيانات مع شبكات الإعلانات، ولا نستخدم بيانات المستخدمين في الإعلانات الموجهة.",
          ],
        },
        {
          title: "التتبع والإعلانات",
          paragraphs: [
            "لا يُجري التطبيق أي تتبع عبر التطبيقات أو المواقع، ولا يستخدم IDFA أو IDFV أو أي معرّفات إعلانية، ولا يستخدم البيانات للإعلانات الموجهة. ولهذا لا يتطلب التطبيق إذن تتبع الإعلانات (ATT).",
          ],
        },
        {
          title: "الاحتفاظ بالبيانات",
          paragraphs: [
            "نحتفظ بالبيانات فقط للمدة اللازمة بشكل معقول للأغراض الموضحة في هذه السياسة، أو لإدارة الحسابات، أو لأغراض الأمان، أو للالتزامات القانونية، أو للاحتياجات التشغيلية المشروعة، ما لم تتطلب ميزة معينة فترة احتفاظ أطول.",
          ],
        },
        {
          title: "أمن البيانات",
          paragraphs: [
            "نطبق تدابير إدارية وتقنية معقولة لحماية المعلومات. ومع ذلك، لا يمكن ضمان أن تكون أي وسيلة نقل أو تخزين إلكتروني آمنة بنسبة 100%.",
          ],
        },
        {
          title: "حقوق المستخدمين وطلبات الخصوصية",
          paragraphs: [
            "يمكنك طلب الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها عن طريق التواصل معنا عبر بريد الخصوصية الموضح في قسم \"تواصل معنا\". سنتعامل مع الطلبات وفقًا لهذه السياسة والمتطلبات النظامية المعمول بها.",
          ],
        },
        {
          title: "الأطفال والسياق التعليمي",
          paragraphs: [
            "التطبيق تطبيق تعليمي مرتبط بالمدارس وقد يُستخدم في سياقات مدرسية، ويخضع الوصول عبر الحسابات المصرح بها لسيطرة الجهة التعليمية. لا نقدم التطبيق ضمن فئة \"مصمم للأطفال\" (Made for Kids) وفق قواعد Apple.",
          ],
        },
        {
          title: "التغييرات على سياسة الخصوصية",
          paragraphs: [
            "قد نحدّث سياسة الخصوصية هذه من وقت لآخر. سيتم نشر أي تغييرات على هذه الصفحة مع تحديث تاريخ \"آخر تحديث\" أعلاه.",
          ],
        },
        {
          title: "تواصل معنا",
          paragraphs: [
            "لأي أسئلة حول سياسة الخصوصية هذه أو لممارسة حقوق الخصوصية الخاصة بك، تواصل معنا عبر:",
          ],
          email: true,
        },
      ],
    },
  },

  en: {
    dir: "ltr",
    langName: "English",
    otherLang: "العربية",
    brand: { name: "Al Maarifah Houses", latin: "بيوت المعرفة", tag: "Educational iOS App" },
    nav: { support: "Support", about: "About", privacy: "Privacy Policy" },
    hero: {
      badge: "Official iOS App Support",
      line1: "Al Maarifah Houses",
      line2: "A bilingual educational digital initiative",
      line3: "designed to promote belonging, participation, achievement, and positive competition.",
      ctaHelp: "Get Help",
      ctaPrivacy: "Privacy Policy",
      meta: ["Bilingual", "Six Houses", "No Tracking"],
    },
    marquee: ["Belonging", "Participation", "Achievement", "Positive Competition", "Recognition", "Al Maarifah Houses"],
    about: {
      chapter: "01",
      title: "About the App",
      p1: "Al Maarifah Houses is an Arabic/English school-house initiative built around six houses. The app supports engagement, achievements, points, voting, competitions, recognition, and public information.",
      p2: "Not all features are available to all users: some administrative and staff features require authorized accounts issued by the educational organization, while public content may be browsed without signing in.",
      pillars: [
        { title: "Belonging", desc: "One-house spirit and teamwork" },
        { title: "Participation", desc: "Student engagement in activities and events" },
        { title: "Achievement", desc: "Documenting and celebrating accomplishments" },
        { title: "Positive Competition", desc: "Points and contests in a sporting spirit" },
      ],
    },
    help: {
      chapter: "02",
      title: "Getting Help",
      intro: "A few simple steps resolve most common issues before contacting support.",
      steps: [
        "Make sure the app is updated to the latest version from the App Store.",
        "Check your internet connectivity.",
        "Close and reopen the app if a page does not load correctly.",
        "If an authorized staff account experiences an access issue, sign out and sign in again.",
        "If notifications are not received, make sure push notifications are allowed for the app in iOS Settings.",
      ],
    },
    faq: {
      chapter: "03",
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What is Al Maarifah Houses?",
          a: "A bilingual educational school-house initiative built around six houses, supporting engagement, achievements, points, voting, competitions, recognition, and public information.",
        },
        {
          q: "Is the app available in Arabic and English?",
          a: "Yes. The app is fully bilingual, and you can switch between Arabic and English inside the app.",
        },
        {
          q: "Do I need an account to use the app?",
          a: "Public content can be browsed without signing in. Some administrative and staff features require an authorized account.",
        },
        {
          q: "Why can some users access features that others cannot?",
          a: "Some features are reserved for authorized account holders, such as the principal, administrators, or staff, based on roles granted by the educational organization.",
        },
        {
          q: "How are house points calculated?",
          a: "Authorized staff award or deduct points based on achievements, participation, and school criteria. Points are aggregated per house and shown in the app's results and standings.",
        },
        {
          q: "Can users vote in campaigns?",
          a: "Yes. The app supports voting in available campaigns. Some voting or evaluation activities may be limited to authorized users depending on the campaign.",
        },
        {
          q: "Why am I not receiving notifications?",
          a: "Make sure notifications are allowed for the app in iOS Settings, the app is updated to the latest version, and your device is connected to the internet.",
        },
        {
          q: "How can I report a technical issue?",
          a: "Contact us through the form on this page or via the support email below, and include a description of the issue, your device model, and the app version.",
        },
        {
          q: "How can I request access to or deletion of my personal data?",
          a: "Send your request to the privacy contact email shown on the Privacy Policy page, and we will handle it as described in the policy.",
        },
        {
          q: "Is my data used for advertising or tracking?",
          a: "No. The app does not use personal data for advertising or for tracking across apps or websites. Full details of the data the app processes are described in the Privacy Policy.",
        },
      ],
    },
    contact: {
      chapter: "04",
      title: "Contact & Support",
      emailLabel: "Support Email",
      note: "For technical support or questions related to the app, please contact us using the email address above.",
      formTitle: "Send us a message",
      name: "Full Name",
      email: "Email Address",
      subject: "Subject",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      successAr: "تم استلام رسالتك بنجاح. شكرًا لتواصلك معنا.",
      successEn: "Your message has been received successfully. Thank you for contacting us.",
      errorAr: "تعذر إرسال الرسالة. يرجى المحاولة مرة أخرى أو التواصل عبر البريد الإلكتروني.",
      errorEn: "Your message could not be sent. Please try again or contact us by email.",
      validation: "Please fill in all fields correctly (message must be at least 10 characters).",
    },
    footer: {
      support: "Support",
      privacy: "Privacy Policy",
      about: "App Information",
      copyright: "© 2026 Dr. Maryam Rashed Sulaiman Alzeyoudi",
      brand: "Al Maarifah Houses",
      emailLabel: "Support:",
    },
    aboutPage: {
      metaTitle: "About Al Maarifah Houses | بيوت المعرفة",
      badge: "App Information",
      title: "About Al Maarifah Houses",
      intro: "A bilingual educational digital initiative combining motivation, belonging, and positive competition in one school community.",
      purposeTitle: "Purpose",
      purpose: "To promote belonging, participation, achievement, and positive competition among students through an interactive digital house system serving the school community.",
      bilingualTitle: "Bilingual Support",
      bilingual: "The app is designed entirely in Arabic and English, with full right-to-left and left-to-right layout support.",
      housesTitle: "The Six-House Concept",
      housesIntro: "The app is built around six houses that compete through points, achievements, and participation in activities and competitions.",
      house: "House",
      accessTitle: "Public Information vs Authorized Staff Functionality",
      publicTitle: "For Everyone",
      publicDesc: "Public content and information can be browsed without signing in.",
      staffTitle: "For Authorized Staff",
      staffDesc: "Administrative features — such as managing points, notifications, and campaigns — require authorized accounts managed by the educational organization.",
      linksTitle: "Useful Links",
      toSupport: "Support Page",
      toPrivacy: "Privacy Policy",
    },
    privacy: {
      metaTitle: "Al Maarifah Houses Privacy Policy | سياسة خصوصية بيوت المعرفة",
      badge: "Official Document",
      title: "Privacy Policy – Al Maarifah Houses",
      updated: "Last updated: July 2026",
      sections: [
        {
          title: "Introduction",
          paragraphs: [
            "This Privacy Policy describes how the Al Maarifah Houses iOS app handles information. The app is a bilingual (Arabic/English) educational school-house initiative built around six houses, designed to promote belonging, participation, achievement, and positive competition.",
            "By using the app, you agree to the practices described in this policy.",
          ],
        },
        {
          title: "Information We Collect",
          paragraphs: ["The app collects the following types of data:"],
          list: [
            "Name — Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "Email Address — Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "User ID — Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "Device ID — the device identifier is the APNs push token, used only for push notifications. Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "Photos — only authorized Principal/Admin users can select images from the iPhone photo library and upload them for app content such as About sections, notifications, or voting campaigns. No videos are collected and no camera access is used. Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "Other User Content — such as point comments, deduction justifications, achievement proposals and notes, review notes, staff voting/evaluation submissions, and support and privacy request text. Purpose: App Functionality. Linked to user: Yes. Tracking: No.",
            "Product Interaction — such as app opens, sessions, selected public page views, login activity timestamps, notification read state, and celebration seen state. Purposes: Analytics and App Functionality.",
          ],
          after: [
            "Some public analytics events use anonymous rotating identifiers, while some staff interaction data is account-linked. Overall Apple disclosure classification: Linked to user: Yes. Tracking: No.",
            "The app does not collect: physical address, phone number, health or fitness data, financial information, precise or coarse location, sensitive information, contacts, emails or text messages, audio data, browsing history, search history, purchases, advertising data, crash data, performance data, other diagnostic data, IDFA, IDFV, or any advertising identifiers, and it does not collect data for advertising or cross-app tracking.",
          ],
        },
        {
          title: "How We Use Information",
          list: [
            "To operate core app functionality such as accounts, roles, houses, points, and achievements.",
            "To administer authorized accounts and staff/admin permissions.",
            "To deliver app-related push notifications.",
            "To present app content such as About sections, campaigns, and recognition.",
            "To understand and improve app usage through product interaction analytics.",
          ],
        },
        {
          title: "Push Notifications",
          paragraphs: [
            "The app uses Apple Push Notification service (APNs), together with a push relay (Emergent push relay / SuprSend), to deliver notifications. The push processor receives: the internal user ID, the platform, and the APNs push token — for notification delivery only.",
            "You can disable notifications at any time in your device's iOS Settings.",
          ],
        },
        {
          title: "Photos and User-Provided Content",
          paragraphs: [
            "Only authorized Principal/Admin users can select images from the device photo library and upload them for app content, such as About sections, notifications, or voting campaigns. The app does not access the camera and does not collect videos.",
            "Authorized users may provide text content such as point comments, deduction justifications, achievement proposals, review notes, voting and evaluation submissions, and support requests. This content is used solely to operate app functionality.",
          ],
        },
        {
          title: "Analytics and Product Interaction",
          paragraphs: [
            "The app records some product interaction events, such as app opens, sessions, selected public page views, login activity timestamps, notification read state, and celebration seen state.",
            "Some public analytics events use anonymous rotating identifiers, while some staff interaction data is account-linked. This information is used for Analytics and App Functionality, and is never used for advertising or tracking.",
          ],
        },
        {
          title: "Data Sharing and Service Providers",
          paragraphs: [
            "We use Apple Push Notification service (APNs) and a push relay (Emergent push relay / SuprSend) to deliver notifications only; the relay receives the internal user ID, platform, and push token.",
            "We do not sell personal data, we do not share data with advertising networks, and we do not use user data for targeted advertising.",
          ],
        },
        {
          title: "Tracking and Advertising",
          paragraphs: [
            "The app performs no cross-app or cross-site tracking, uses no IDFA, IDFV, or other advertising identifiers, and uses no data for targeted advertising. As a result, no App Tracking Transparency (ATT) permission is required for advertising tracking.",
          ],
        },
        {
          title: "Data Retention",
          paragraphs: [
            "Data is retained only for as long as reasonably necessary for the purposes described in this policy, for account administration, security, legal obligations, or legitimate operational needs, unless a specific feature requires longer retention.",
          ],
        },
        {
          title: "Data Security",
          paragraphs: [
            "We apply reasonable administrative and technical measures to protect information. However, no method of electronic transmission or storage can be guaranteed to be 100% secure.",
          ],
        },
        {
          title: "User Rights and Privacy Requests",
          paragraphs: [
            "You may request access to, correction of, or deletion of your personal data by contacting us at the privacy email listed in the Contact Us section. Requests are handled in line with this policy and applicable legal requirements.",
          ],
        },
        {
          title: "Children and Educational Context",
          paragraphs: [
            "The app is an educational, school-related application and may be used in school contexts; access through authorized accounts is controlled by the organization. We do not present the app as “Made for Kids” under Apple's rules.",
          ],
        },
        {
          title: "Changes to This Privacy Policy",
          paragraphs: [
            "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date above.",
          ],
        },
        {
          title: "Contact Us",
          paragraphs: [
            "For any questions about this Privacy Policy or to exercise your privacy rights, contact us at:",
          ],
          email: true,
        },
      ],
    },
  },
};
